/**
 * SchemasList Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';
import search from 'javascript-array-search';

// Selectors
import { selectSchemas } from '../../../../../../services/schemas/selectors';

// Workspaces
import {
    makeSelectQueryStringValue,
    makeSelectQueryStringNumberValue
} from '../../../../../../workspaces/react-router-selectors';

// Utils
import orderBy from '../../../../../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectData = createDeepEqualSelector(selectSchemas, schemasState =>
    Object.values(schemasState)
);

const selectFilteredData = createDeepEqualSelector(
    [selectData, makeSelectQueryStringValue('search')],
    (dataState, searchState) => {
        const filteredSchemas = dataState.filter(
            schema => !schema.deletedAt && !schema.eventTypeId
        );
        return search(filteredSchemas, searchState, ['name']);
    }
);

const selectDataLength = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => filteredDataState.length
);

const selectOrderedData = createDeepEqualSelector(
    [selectFilteredData, makeSelectQueryStringValue('sort')],
    (filteredDataState, sortState = 'name_asc') => {
        if (!filteredDataState || !sortState) {
            return filteredDataState;
        }
        const attributes = sortState.split('_');
        const propertyName = attributes[0];
        const order = attributes[1] || 'asc';
        return orderBy(filteredDataState, propertyName, order);
    }
);

const selectPaginatedData = createDeepEqualSelector(
    [
        selectOrderedData,
        makeSelectQueryStringNumberValue('page'),
        makeSelectQueryStringNumberValue('count')
    ],
    (orderedDataState, pageState = 1, countState = 25) => {
        const begin = (pageState - 1) * countState;
        const end = pageState * countState;
        return orderedDataState.slice(begin, end);
    }
);

const selectIds = createDeepEqualSelector(
    selectPaginatedData,
    paginatedDataState =>
        paginatedDataState && paginatedDataState.map(value => value.id)
);

export {
    selectData,
    selectDataLength,
    selectFilteredData,
    selectOrderedData,
    selectIds
};
